import React from "react";
import { Star } from "phosphor-react";
import styles from "./ssearch.module.scss";
import { Link, useLocation } from "react-router-dom";

const Index = ({ data }) => {
  const params = useLocation();
  return (
    <>
      <Link to={`${params.pathname}/${data.id}`} className={styles.movieCard}>
        <div
          className={`${styles.movieCardImg} !h-[200px] sm:!h-[250px] md:!h-[250px] lg:!h-[200px] xl:!h-[300px]`}
        >
          <div className="absolute flex items-center space-x-2 z-[11] top-2 right-2 px-4 py-1 bg-white rounded-full">
            <p>{data.imdb_rating}</p>
            <Star className="text-yellow-500" size={16} weight="fill" />
          </div>
          <div
            className={`${styles.movieCardhov} !h-[200px] sm:!h-[250px] md:!h-[250px] lg:!h-[200px] xl:!h-[300px]`}
          ></div>
          <img className="rounded-xl" src={data.poster} alt="" />
        </div>
        <div className="block py-4">
          <h1 className="lg:text-lg">
            {data.title.length >= 25
              ? `${data.title.slice(0, 24)}...`
              : data.title}
          </h1>
          <div className="flex space-x-4 items-center overflow-auto whitespace-nowrap">
            <div className="flex text-sm text-slate-500 font-normal">
              {data.genres.map((item, index) => (
                <div key={index} className="flex items-center">
                  <p>{item}</p>
                  <div className="h-[4px] w-[4px] mx-2 rounded-full bg-slate-600"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Link>
    </>
  );
};

export default Index;
